import { IconDefinition } from '@ant-design/icons-angular';
import {
  UnorderedListOutline,
  FormOutline,
  BarChartOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  HomeOutline,
  TeamOutline,
  FileTextOutline,
  PlusOutline,
  EditOutline,
  DeleteOutline,
  EyeOutline,
  DownloadOutline,
  SearchOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  BellOutline,
  UserOutline,
  MailOutline,
  LogoutOutline,
  CheckCircleOutline,
  CloseCircleOutline,
  WarningOutline,
  ExclamationCircleOutline,
  UploadOutline,
  LoginOutline,
  FileExcelOutline,
  FilePdfOutline,
  InfoCircleOutline,
  ReloadOutline,
  ShopOutline,
  TagsOutline,
  FontSizeOutline,
  PictureOutline,
  AppstoreOutline,
  ApartmentOutline,
  WalletOutline,
  EnvironmentOutline,
  ClusterOutline,
  CalendarOutline
} from '@ant-design/icons-angular/icons';

export const icons: IconDefinition[] = [
  UnorderedListOutline,
  FormOutline,
  BarChartOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  HomeOutline,
  TeamOutline,
  FileTextOutline,
  PlusOutline,
  EditOutline,
  DeleteOutline,
  EyeOutline,
  DownloadOutline,
  SearchOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  BellOutline,
  UserOutline,
  MailOutline,
  LogoutOutline,
  CheckCircleOutline,
  CloseCircleOutline,
  WarningOutline,
  ExclamationCircleOutline,
  UploadOutline,
  LoginOutline,
  FileExcelOutline, 
  FilePdfOutline, 
  InfoCircleOutline,
  ReloadOutline,
  ShopOutline,
  TagsOutline,
  FontSizeOutline,
  PictureOutline,
  AppstoreOutline,
  ApartmentOutline,
  WalletOutline,
  EnvironmentOutline,
  ClusterOutline,
  CalendarOutline
];